import styled from 'styled-components'
import { theme } from '../../../../style/theme'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const SvgTableWrap = styled.div`
	position: relative;
	height: ${props => props.height}px;
	width: ${props => props.width}px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-left: -10px;

	> svg {
		position: absolute;
		height: ${props => props.height}px;
		width: ${props => props.width}px;

		&.vertical {
			transform: rotate(90deg);
			height: ${props => props.width}px;
			width: ${props => props.height}px;
		}

		.lf-hidden {
			visibility: hidden;
		}
	}

	&.sizeWithEm {
		height: ${props => props.height}em;
		width: ${props => props.width}em;
		margin-left: -.63em;


		> svg {
			position: absolute;
			height: ${props => props.height}em;
			width: ${props => props.width}em;

			&.vertical {
				transform: rotate(90deg);
				height: ${props => props.width}em;
				width: ${props => props.height}em;
			}

			.lf-hidden {
				visibility: hidden;
			}
		}
	}

	&.round {
		margin: -1.25em;
	}

	&.orange .grayTable {
		fill: ${colorTheme.restaurantSettings.table.orange};
	}

	&.orange .colorTable {
		fill: ${colorTheme.restaurantSettings.table.orange};
	}

	&.red .colorTable {
		fill: ${colorTheme.restaurantSettings.table.red};
	}

	&.gray .colorTable {
		fill: ${colorTheme.restaurantSettings.table.gray};
	}

	&.disabled .colorTable{
		fill: ${colorTheme.restaurantSettings.table.disabled.disabled};
	}

	@keyframes scalePulse {
		0%, 100% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.2);
		}
	}

	&.scalePulse {
		animation: scalePulse 0.8s ease-in-out infinite;
	}
`
SvgTableWrap.displayName = 'SvgTableWrap'
export const TableData = styled.div`
	display: grid;
	grid-template-rows: max-content 1.88em;
	justify-items: center;
	align-content: space-between;
	gap: .63em;
	font-size: 1rem;
	height: 55%;
	max-height: 8em;
	z-index: 1;
	color: ${colorTheme.restaurantSettings.table.title};
	flex-shrink: 0;

	&.vertical {
		height: auto;
	}

	&.paid-before-with-icon-and-waiter {
		gap: .1em;
	}

	&.waiterCall {
		height: auto;
	}
`

TableData.displayName = 'TableData'

export const TableDataNumber = styled.div`
	color: ${colorTheme.restaurantSettings.table.title}
	text-align: center;
	font-family: ${theme.fontRoboto};
	font-size: 1em;
	font-style: normal;
	font-weight: 500;
	line-height: normal;

	&.disabled {
		color: ${colorTheme.restaurantSettings.table.disabled.title}

	}
`
TableDataNumber.displayName = 'TableDataNumber'

export const TableDataIconWrap = styled.div`
	cursor: pointer;
	font-size: 1rem;
	margin-top: .3em;

	> svg {
		width: 2.25em;
		height: 2.25em;
	}

	&.qr-code svg {
		width: 2.25em;
		height: 2.25em;
	}

	&.small.qr-code svg {
		width: 2em;
		height: 2em;
	}

	&.paid-before svg {
		width: 1.25em;
		height: 1.25em;
		fill: ${colorTheme.restaurantSettings.table.icon};
		flex-shrink: 0;

		:last-child {
			margin-left: 0.13em;
		}
	}

	&.paid-before-with-icon-and-waiter svg {
		width: 1em;
		height: 1em;
	}
`
TableDataIconWrap.displayName = 'TableDataIconWrap'

export const TableDataPrice = styled.div`
	color: ${colorTheme.restaurantSettings.table.title};
	font-family: ${theme.fontRoboto};
	font-size: 1.25em;
	font-weight: 700;
	padding: .25em .44em;

	&.readyFood {
		font-size: 1em;
	}

	&.paid-before {
		color: ${colorTheme.restaurantSettings.table.payBeforeTitle};
	}

	&.disabled {
		color: ${colorTheme.restaurantSettings.table.disabled.title};
	}
`
TableDataPrice.displayName = 'TableDataPrice'

export const TableDataPriceWrap = styled.div`
	font-size: 1em;
	border-radius: .88em;
	border: 1px solid ${colorTheme.restaurantSettings.table.green};
	background: ${colorTheme.restaurantSettings.table.backgroundPrice};
	display: flex;
	justify-content: center;
	align-items: center;

	&.paid-before {
		background: ${colorTheme.restaurantSettings.table.green};
	}

	&.disabled {
		border: 1px solid ${colorTheme.restaurantSettings.table.disabled.backgroundPrice};
	}
`
TableDataPriceWrap.displayName = 'TableDataPriceWrap'

export const TableDataWaiter = styled.div`
	width: 100%;
	height: 100%;
	font-size: .88em;
	word-break: break-word;
	color: ${colorTheme.restaurantSettings.table.title};
`
TableDataWaiter.displayName = 'TableDataWaiter'


export const TableDataWaiterWrap = styled.div`
	font-size: 1rem;
	width: 7.25em;
	height: fit-content;
	padding: .13em .25em;
	display: inline-flex;
	justify-content: center;
	align-items: center;

	border-radius: .33em;
	border: 1px solid ${colorTheme.restaurantSettings.table.title};
	text-align: center;
	background: ${colorTheme.restaurantSettings.table.backgroundWaiterData};

	&.mg-t {
		margin-top: .6em;
	}

	&.rectangle:not(.vertical),
	&.bar_counter:not(.vertical) {
		width: max-content;
	}
`
TableDataWaiterWrap.displayName = 'TableDataWaiterWrap'
export const TableDataContent = styled.div`
	font-size: 1rem;
	display: grid;
	grid-template-rows: max-content 1.94em;
	justify-items: center;
	align-content: center;
	flex-grow: 1;

	&.qr-code, &.restaurant_settings {
		grid-template-rows: max-content 2.8em;
	}
`
TableDataContent.displayName = 'TableDataContent'

const TIMER_HEIGHT = 1.94

export const TableDataTimer = styled.div`
	position: absolute;
	top: ${({ top }) => `calc(${top || 0}px - ${TIMER_HEIGHT}em)`};
	left: 50%;
	transform: translateX(-50%);
	min-height: ${TIMER_HEIGHT}em;
	padding: 0.13em 0.56em 0.13em 0.31em;
	display: flex;
	align-items: center;
	gap: 0.31em;
	border-radius: 1em;
	background-color: ${colorTheme.restaurant.table.timer.background};
	z-index: 2;

	> svg {
		width: 1.31em;
		height: 1.31em;
		flex-shrink: 0;
		fill: ${colorTheme.restaurant.table.timer.icon};
	}

	&.bar_counter {
		top: calc(-0.63em - ${TIMER_HEIGHT}em);
	}

	&.timer-limit {
		background-color: ${colorTheme.restaurant.table.timer.limit};
	}
`
TableDataTimer.displayName = 'TableDataTimer'

export const TableDataTimerText = styled.div`
	color: ${colorTheme.restaurant.table.timer.text};
	text-align: center;
	font-family: ${theme.fontRobotoMedium};
	font-size: 1.13em;
`
TableDataTimerText.displayName = 'TableDataTimerText'
